import {
    allFetch,
    ResultObj
} from "../Domain";

/**
* @description 行事曆細項查詢
* @param cm_id 主項流水號
* @param date_start 日期起
* @param date_end 日期迄
*/

export interface CalendarDetailSearchParams {
    cm_id: string,
    date_start: string,
    date_end: string,
}
export interface CalendarDetailSearchResItem {
    dt: {
        cd_id: number;
        cm_id: string;
        date: string;
        holiday: string;
        note: string;
    }[],
    dt_year: {
        year: string,
    }[]
}
/** @description 行事曆細項查詢 */
export const CalendarDetailSearch =
    async (obj: CalendarDetailSearchParams = {
        cm_id: '',
        date_start: '',
        date_end: ''
    }): Promise<ResultObj<CalendarDetailSearchResItem>> => await allFetch('Calendar/CalendarDetailSearch', obj);


/** 行事曆主項查詢 (參數)
* @description 行事曆主項查詢 (參數)
* @param cm_id 主項流水號
* @param calendar_name 行事曆名稱
* @param visible 是否可見
* @param page 頁碼
* @param num_per_page 一頁幾筆
*/

export interface CalendarMasterSearchParams {
    cm_id: string,
    calendar_name: string,
    visible: string,
    page: number,
    num_per_page: number,
}
/** @description 行事曆主項查詢 (回傳) */
export interface CalendarMasterSearchResItem {
    calendar_name: string;
    cm_id: string;
    visible: string;
}
/** @description 行事曆主項查詢 */
export const CalendarMasterSearch =
    async (obj: CalendarMasterSearchParams = {
        cm_id: '',
        calendar_name: '',
        visible: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<CalendarMasterSearchResItem[]>> => await allFetch('Calendar/CalendarMasterSearch', obj);

/** @description 行事曆主項新增 (參數) */
export interface CalendarMasterCreateParams {
    calendar_name: string;
}
/** @description 行事曆主項新增 */
export const CalendarMasterCreate =
    async (obj: CalendarMasterCreateParams = {
        calendar_name: '',
    }): Promise<ResultObj<string>> => await allFetch('Calendar/CalendarMasterCreate', obj);


/** @description 行事曆主項修改 (參數) */
export interface CalendarMasterUpdateParams {
    cm_id: string;
    calendar_name: string;
    visible: string;
}
/** @description 行事曆主項修改 */
export const CalendarMasterUpdate =
    async (obj: CalendarMasterUpdateParams = {
        cm_id: '',
        calendar_name: '',
        visible: '',
    }): Promise<ResultObj> => await allFetch('Calendar/CalendarMasterUpdate', obj);

/** @description 行事曆細項修改 (參數) */
export interface CalendarDetailUpdateParams {
    cm_id: string;
    CalendarDetailCreate: CalendarDetail[];
    CalendarDetailUpdate: CalendarDetail[];
    CalendarDetailDelete: CalendarDetail[];
}
/** @description 行事曆細項修改 */
export const CalendarDetailUpdate =
    async (obj: CalendarDetailUpdateParams = {
        cm_id: '',
        CalendarDetailCreate:[],
        CalendarDetailUpdate: [],
        CalendarDetailDelete:[],
    }): Promise<ResultObj<CalendarMasterSearchResItem[]>> => await allFetch('Calendar/CalendarDetailUpdate', obj);

export interface CalendarDetail {
    date: string,
    holiday: string,
    note: string
}